import {OrderDepthLevelRecord, PricingOrderRecord} from "../types/OrderDepthRecord";
import {Comparator} from "../../types/GenericTypes";
import {OrderDepthVolumeChange} from "./OrderDepthVolumeChange";

export type OrderDepthModels = ReadonlyArray<OrderDepthModel>;

export class OrderDepthModel implements OrderDepthLevelRecord {

    private constructor(private readonly record: OrderDepthLevelRecord,
                        public readonly style: string,
                        public readonly collapsed: boolean,
                        public readonly hasMatch: boolean,
                        public readonly change: OrderDepthVolumeChange) {
    }

    public get count(): number {
        return this.record.count;
    }

    public get price(): number {
        return this.record.price;
    }

    public get volume(): number {
        return this.record.volume;
    }

    public get value(): number {
        return this.record.price * this.record.volume;
    }

    public get orders(): ReadonlyArray<PricingOrderRecord> {
        return this.record.orders;
    }

    public get hasMultipleOrders(): boolean {
        return this.orders.length > 1;
    }

    public static create(record: OrderDepthLevelRecord,
                         style: string,
                         collapsed: boolean,
                         hasMatch: boolean,
                         change: OrderDepthVolumeChange): OrderDepthModel {
        return new OrderDepthModel(record, style, collapsed, hasMatch, change);
    }
}

export function sortDepthByPrice(): Comparator<OrderDepthModel> {
    return (a, b) => a.price - b.price;
}
